import { render } from "./EscritorioAvisos.vue?vue&type=template&id=fc22fa6a"
import script from "./EscritorioAvisos.vue?vue&type=script&lang=js"
export * from "./EscritorioAvisos.vue?vue&type=script&lang=js"

import "./EscritorioAvisos.vue?vue&type=style&index=0&id=fc22fa6a&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__